import Icon from "@mui/icons-material/HowToReg";
import RazaEventAttendancesCreate from "./RazaEventAttendancesCreate";
import RazaEventAttendancesList from "./RazaEventAttendancesList";

export default {
  list: RazaEventAttendancesList,
  create: RazaEventAttendancesCreate,
  icon: Icon,
  label: "Ohbat attendance",
  options: { label: "Ohbat attendance" },
  name: "razaEventAttendances",
};
